import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AsociacionFirmaComponent } from './asociacion-firma-documento.component'; 
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AsociacionFirmaComponent],
  imports: [
    SharedModule,
    CommonModule,
  ],
  exports: [
    AsociacionFirmaComponent // Exporta el componente para que otros módulos puedan usarlo
  ]
})
export class AsociacionFirmaModule { }
